module.exports = "/_next/static/images/customer-review-sarah2@2x-min-4b46a26d28142f7434d9ae1e99bd54a6.png.webp";